import {
  carEngineDisplacementInCM3Options,
  kmOptions,
  motoEngineDisplacementInCM3Options,
  powerInHpOptions,
  pricesOptions,
} from 'enums/G';
import { getMinAndMaxPlaceholders } from './getMinAndMaxPlaceholders';

type Options =
  | typeof carEngineDisplacementInCM3Options
  | typeof motoEngineDisplacementInCM3Options
  | typeof pricesOptions
  | typeof kmOptions
  | typeof powerInHpOptions;

export const getOptions = (options: Options | ReadonlyArray<number>): Array<{ value: string; inputDisplay: string }> =>
  options.map((value) => ({
    value: value.toString(),
    inputDisplay: getMinAndMaxPlaceholders(value, options),
  }));
